module.exports = __webpack_public_path__ + "img/nexus.727e1260.webp";